export const model3dinfors  = {
  info:[
    //泵
    {  
      devPath:'static/dev2.glb',
      visibleDotsListinfor:['Loft002','Box053','NGon636','Cylinder558'],
      degToRadY:270,
      degToRadX:0,
      current:0,
      dotsinfo1:{
          leftX:0,
          topY:0,
          position:{
            x:null,
            y:null
          },
          
          sensorval:[],
          
      },
      dotsinfo2:{
          leftX:0,
          topY:0,
          position:{
            x:null,
            y:null
          },
        
          sensorval:[],
        
      },
      dotsinfo3:{
          leftX:0,
          topY:0,
          position:{
            x:null,
            y:null
          },
        
          sensorval:[],
        
      },
      dotsinfo4:{
          leftX:0,
          topY:0,
          position:{
            x:null,
            y:null
          },
          
          sensorval:[],
        
      }
    },
    //电机
    // { 
    //   device_name:['聚合釜卸料泵_PVCYZ277'],
    //   devPath:'static/smalldev2.glb',
    //   visibleDotsListinfor:['Loft002','Rectangle153','Cylinder659','Cylinder816'],
    //   degToRadY:300,
    //   degToRadX:20,
    //   current:0,
    //   dotsinfo1:{
    //       leftX:-98,
    //       topY:58,
    //       position:{
    //         x:null,
    //         y:null
    //       },
          
    //       sensorval:[],
          
    //   },
    //   dotsinfo2:{
    //       leftX:-8,
    //       topY:-18,
    //       position:{
    //         x:null,
    //         y:null
    //       },
    //       sensorval:[],
    //   },
    //   dotsinfo3:{
    //       leftX:0,
    //       topY:230,
    //       position:{
    //         x:null,
    //         y:null
    //       },
        
    //       sensorval:[],
        
    //   },
    //   dotsinfo4:{
    //       leftX:98,
    //       topY:50,
    //       position:{
    //         x:null,
    //         y:null
    //       },
          
    //       sensorval:[],
        
    //   }
    // },
    // 出炉风机
    {   
        device_name:[''],
        devPath:'static/dev1.glb',
        visibleDotsListinfor:['NGon700','NGon708','NGon711','Cylinder09'],
        degToRadY:0,
        degToRadX:60,
        current:0,
        dotsinfo1:{
            // leftX:390,
            // topY:-120,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            sensorval:[],
           
           
        },
        dotsinfo2:{
            // leftX:240,
            // topY:-90,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
          
            sensorval:[],
          
        },
        dotsinfo3:{
            // leftX:-250,
            // topY:60,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
         
            sensorval:[],
         
        },
        dotsinfo4:{
            // leftX:-390,
            // topY:340,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
           
            sensorval:[],
          
        }
    },
    // 风机2
    {  
        device_name:['钛风机_SJYZ061','氯气鼓风机_GJYZ180','氯气鼓风机_GJYZ181','氯气洗涤泵_GJYZ182','氯气洗涤泵_GJYZ183',
            '罗茨风机_PVCYZ358','罗茨风机_PVCYZ359','罗茨风机_PVCYZ136'         
        ],
        devPath:'static/dev3.glb',
        visibleDotsListinfor:['Line174','Line176','NGon788','Line147'],
        degToRadY:0,
        degToRadX:0,
        current:0,
        dotsinfo1:{
            // leftX:-340,
            // topY:160,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            
            sensorval:[],
            
        },
        dotsinfo2:{
            // leftX:-160,
            // topY:400,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            sensorval:[],
          
        },
        dotsinfo3:{
            // leftX:260,
            // topY:-160,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
          
            sensorval:[],
          
        },
        dotsinfo4:{
            // leftX:240,
            // topY:130,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            
            sensorval:[],
          
        }
    },
    // 导热油泵
    {   
        device_name:[''],
        devPath:'static/dev4.glb',
        visibleDotsListinfor:['Cylinder530','Box090','Cylinder1938','NGon883'],
        degToRadY:90,
        degToRadX:20,
        current:0,
        dotsinfo1:{
            // leftX:-100,
            // topY:60,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            
            sensorval:[],
           
        },
        dotsinfo2:{
            // leftX:-200,
            // topY:250,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
          
            sensorval:[],
          
        },
        dotsinfo3:{
            // leftX:200,
            // topY:-20,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
         
            sensorval:[],
         
        },
        dotsinfo4:{
            // leftX:100,
            // topY:50,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
           
            sensorval:[],
          
        }
    },
    // 发动机
    {   
        device_name:[''],
        devPath:'static/dev5.glb',
        visibleDotsListinfor:['Loft002','Rectangle153','Cylinder624','Cylinder832'],
        degToRadY:270,
        degToRadX:0,
        current:0,
        dotsinfo1:{
            // leftX:-100,
            // topY:60,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            
            sensorval:[],
           
        },
        dotsinfo2:{
            // leftX:10,
            // topY:250,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
          
            sensorval:[],
          
        },
        dotsinfo3:{
            // leftX:0,
            // topY:-20,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
         
            sensorval:[],
         
        },
        dotsinfo4:{
            // leftX:100,
            // topY:50,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
           
            sensorval:[],
          
        }
    },
    // 卷扬机
    {
    device_name:[''],
    devPath:'static/dev6.glb',
    visibleDotsListinfor:['Line111','Line190','Line189','Cylinder1628'],
    degToRadY:90,
    degToRadX:0,
    current:0,
    dotsinfo1:{
        // leftX:-100,
        // topY:60,
        leftX:0,
        topY:0,
        position:{
            x:null,
            y:null
        },
        
        sensorval:[],
        
    },
    dotsinfo2:{
        // leftX:-320,
        // topY:240,
        leftX:0,
        topY:0,
        position:{
            x:null,
            y:null
        },
        
        sensorval:[],
        
    },
    dotsinfo3:{
        // leftX:0,
        // topY:-20,
        leftX:0,
        topY:0,
        position:{
            x:null,
            y:null
        },
        
        sensorval:[],
        
    },
    dotsinfo4:{
        // leftX:410,
        // topY:120,
        leftX:0,
        topY:0,
        position:{
            x:null,
            y:null
        },
        
        sensorval:[],
        
    }
    },
    // 石灰大倾角
    {  
      device_name:[''],
        devPath:'static/dev7.glb',
        visibleDotsListinfor:['NGon692','Line131','Line132','Line126'],
        degToRadY:90,
        degToRadX:0,
        current:0,
        dotsinfo1:{
            // leftX:-250,
            // topY:120,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            
            sensorval:[],
           
        },
        dotsinfo2:{
            // leftX:-450,
            // topY:325,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
          
            sensorval:[],
          
        },
        dotsinfo3:{
            // leftX:0,
            // topY:-20,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
         
            sensorval:[],
         
        },
        dotsinfo4:{
            // leftX:720,
            // topY:-20,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
           
            sensorval:[],
          
        }
    },
    // 循环水泵
    {   
      device_name:['新大循环水泵_SJYZ064','新大循环水泵_SJYZ065','新大循环水泵_SJYZ066','新大循环水泵_SJYZ067',
        '新大循环水泵_SJYZ068','新大循环水泵_SJYZ069','老循环水泵_SJYZ074','老循环水泵_SJYZ075',
        '老循环水泵_SJYZ076','老循环水泵_SJYZ077','循环冷却水泵_GJYZ077','循环冷却水泵_GJYZ078',
        '循环冷却水泵_GJYZ079','循环冷却水泵_GJYZ080','循环水泵_PVCYZ195','循环水泵_PVCYZ196','循环水泵_PVCYZ197',
        '循环水泵_PVCYZ198','循环水泵_PVCYZ199','循环水泵_PVCYZ200'
      ],
      devPath:'static/dev8.glb',
      visibleDotsListinfor:['NGon692','NGon779','Line126','NGon824'],
      degToRadY:270,
      degToRadX:30,
      current:0,
      dotsinfo1:{
          // leftX:-510,
          // topY:130,
          leftX:0,
          topY:0,
          position:{
            x:null,
            y:null
          },
          sensorval:[],
      },
      dotsinfo2:{
          // leftX:0,
          // topY:240,
          leftX:0,
          topY:0,
          position:{
            x:null,
            y:null
          },
        
          sensorval:[],
        
      },
      dotsinfo3:{
          // leftX:400,
          // topY:-50,
          leftX:0,
          topY:0,
          position:{
            x:null,
            y:null
          },
        
          sensorval:[],
        
      },
      dotsinfo4:{
          // leftX:100,
          // topY:120,
          leftX:0,
          topY:0,
          position:{
            x:null,
            y:null
          },
          
          sensorval:[],
      }
    },
    // 皮带机
    {
        device_name:[''],
        devPath:'static/dev9.glb',
        visibleDotsListinfor:['Loft002','NGon93','NGon80','Line131'],
        degToRadY:270,
        degToRadX:60,
        current:0,
        dotsinfo1:{
            // leftX:-440,
            // topY:-60,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            sensorval:[],
        },
        dotsinfo2:{
            // leftX:0,
            // topY:-10,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            sensorval:[],
        },
        dotsinfo3:{
            // leftX:250,
            // topY:300,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            sensorval:[],
        },
        dotsinfo4:{
            // leftX:94,
            // topY:60,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            sensorval:[],
        }
    },
    // 冰机
    {   
      
        device_name:['冰机_GJYZ040','冰机_GJYZ041','冰机_GJYZ042','冰机_GJYZ043'],
        devPath:'static/冰机.glb',
        visibleDotsListinfor:['Cylinder4591','Cylinder7562','Line175','Capsule005'],
        degToRadY:270,
        degToRadX:0,
        current:0,
        dotsinfo1:{
            // leftX:-640,
            // topY:180,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            
            sensorval:[],
            
        },
        dotsinfo2:{
            // leftX:-8,
            // topY:240,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
          
            sensorval:[],
          
        },
        dotsinfo3:{
            // leftX:0,
            // topY:240,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
          
            sensorval:[],
          
        },
        dotsinfo4:{
            // leftX:640,
            // topY:30,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            
            sensorval:[],
          
        }
    },
    // 电解氢压机
    {  
        
        device_name:['氢压机_SJYZ055','氢压机_SJYZ056','氢压机_SJYZ057','氢压机_SJYZ085','氢压机_SJYZ086','氢压机_GJYZ200','氢压机_GJYZ201','氢压机_GJYZ202'],
        devPath:'static/电解氢压机.glb',
        visibleDotsListinfor:['NGon1367','Line033','Line202','Cylinder6746'],
        degToRadY:270,
        degToRadX:0,
        current:0,
        dotsinfo1:{
            // leftX:-210,
            // topY:90,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            
            sensorval:[],
            
        },
        dotsinfo2:{
            // leftX:160,
            // topY:240,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
          
            sensorval:[],
          
        },
        dotsinfo3:{
            // leftX:0,
            // topY:240,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
          
            sensorval:[],
          
        },
        dotsinfo4:{
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            
            sensorval:[],
          
        }
    },
    // 氯压机
    {   
        device_name:['氯气压缩机_GJYZ196'],
        devPath:'static/氯压机.glb',
        visibleDotsListinfor:['Cylinder4591','Cylinder7562','Line175','Capsule005'],
        degToRadY:180,
        degToRadX:20,
        current:0,
        dotsinfo1:{
            // leftX:0,
            // topY:180,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            
            sensorval:[],
            
        },
        dotsinfo2:{
            // leftX:-8,
            // topY:240,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
          
            sensorval:[],
          
        },
        dotsinfo3:{
            // leftX:0,
            // topY:240,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
          
            sensorval:[],
          
        },
        dotsinfo4:{
            // leftX:0,
            // topY:30,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            
            sensorval:[],
          
        }
    },
    // 煤磨机
    {
        device_name:[''],
        devPath:'static/煤磨机.glb',
        visibleDotsListinfor:['Cylinder1776','ChamferBox004','NGon864','Cylinder2933'],
        degToRadY:-90,
        degToRadX:0,
        current:0,
        dotsinfo1:{
            // leftX:-600,
            // topY:220,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            
            sensorval:[],
            
        },
        dotsinfo2:{
            // leftX:200,
            // topY:300,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
          
            sensorval:[],
          
        },
        dotsinfo3:{
            // leftX:0,
            // topY:-10,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
          
            sensorval:[],
          
        },
        dotsinfo4:{
            // leftX:420,
            // topY:-100,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            
            sensorval:[],
          
        }
    },
    // 片碱机
    {
        device_name:['片碱机_GJYZ073','片碱机_GJYZ074','片碱机_GJYZ075','片碱机_GJYZ076','片碱机_GJYZ121','片碱机_GJYZ122'],
        devPath:'static/片碱机.glb',
        visibleDotsListinfor:['Cylinder1776','Box118','Line155','NGon931'],
        degToRadY:-90,
        degToRadX:20,
        current:0,
        dotsinfo1:{
            // leftX:-430,
            // topY:160,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            
            sensorval:[],
            
        },
        dotsinfo2:{
            // leftX:-8,
            // topY:240,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
          
            sensorval:[],
          
        },
        dotsinfo3:{
            // leftX:-240,
            // topY:200,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
          
            sensorval:[],
          
        },
        dotsinfo4:{
            // leftX:700,
            // topY:80,
            leftX:0,
            topY:0,
            position:{
              x:null,
              y:null
            },
            
            sensorval:[],
          
        }
    },
]
}